export const ClientSettingKeys = {
    IsCalibratorEnabled: 'IsCalibratorEnabled',
    Desktop_AlwaysOnTop: 'Desktop_AlwaysOnTop',
    Desktop_CanClose: 'Desktop_CanClose',
    Desktop_IsLocked: 'Desktop_IsLocked',
    Desktop_Height: 'Desktop_Height',
    Desktop_Width: 'Desktop_Width',
    Desktop_SurveyTimeoutSeconds: 'Desktop_SurveyTimeoutSeconds',
    Desktop_AllowTaskbarFlash: 'Desktop_AllowTaskbarFlash',
    Desktop_HorizontalPosition: 'Desktop_HorizontalPosition',
    Desktop_VerticalPosition: 'Desktop_VerticalPosition',
    DefaultTimeSpanLengthInDays: 'DefaultTimeSpanLengthInDays',
    DefaultTimeSpanStartDate: 'DefaultTimeSpanStartDate',
    DefaultTimeSpanEndDate: 'DefaultTimeSpanEndDate',
    DefaultPasswordHash: 'DefaultPasswordHash',
    DefaultSecurityStamp: 'DefaultSecurityStamp',
    DateForTodayFeature: 'DateForTodayFeature',
    StartDateForLastWeekFeature: 'StartDateForLastWeekFeature',
    EndDateForLastWeekFeature: 'EndDateForLastWeekFeature',
    StartDateForLastMonthFeature: 'StartDateForLastMonthFeature',
    EndDateForLasMonthFeature: 'EndDateForLasMonthFeature',
};

export const ZRole = {
    Agent: 1,
    Supervisor: 2,
    Manager: 3,
    Admin: 4,
    SuperAdmin: 5
}

export const ProcessFailureStatusType = {
    Open: 1,
    Pending: 2,
    InnerLoop: 3,
    OuterLoop: 4,
};

export const ProcessFailureStatusTypeDictionary = {
    1: 'Open',
    2: 'Pending',
    3: 'InnerLoop',
    4: 'OuterLoop',
};

export const ActionStatus = {
    NotStarted: 0,
    InProgress: 1,
    MarkedComplete: 2,
    Disregarded: 3,
    Verified: 4,
};

export const ActionStatusDictionary = {
    0: 'NotStarted',
    1: 'InProgress',
    2: 'MarkedComplete',
    3: 'Disregarded',
    4: 'Verified',
};

export const ActionType = {
    Compliance: 0,
    Calibration: 1,
    Anomaly: 2,
};

export const ActionTypeDictionary = {
    0: 'Compliance',
    1: 'Calibration',
    2: 'Anomaly',
};

export const CalibrationStatus = {
    Jibed: 1,
    NotJibed: 2,
};

export const CalibrationStatusDictionary = {
    1: 'Jibed',
    2: 'NotJibed',
};

export const AlertStatus = {
    New: 1,
    Viewed: 2,
    Read: 3,
    Delete: 4,
};

export const AlertStatusDictionary = {
    1: 'New',
    2: 'Viewed',
    3: 'Read',
    4: 'Delete',
};

export const FileType = {
    Original: 1,
    Cropped: 2,
    Resized_1024_1024: 3,
    Resized_512_512: 4,
    Resized_256_256: 5,
    Resized_60_60: 6,
};

export const FileTypeDictionary = {
    1: 'Original',
    2: 'Cropped',
    3: 'Resized_1024_1024',
    4: 'Resized_512_512',
    5: 'Resized_256_256',
    6: 'Resized_60_60',
};

export const HealthStatusType = {
    Success: 1,
    Fail: 2,
    Attention: 3,
    Complete: 4,
    Incomplete: 5,
};

export const HealthStatusTypeDictionary = {
    1: 'Success',
    2: 'Fail',
    3: 'Attention',
    4: 'Complete',
    5: 'Incomplete',
};

export const SpecialSites = {
    Beta: 176,
};

export const SpecialSitesDictionary = {
    176: 'Beta',
};

export const SpecialSurveyQuestion = {
    WIP: 115,
};

export const SpecialSurveyQuestionDictionary = {
    115: 'WIP',
};

export const LanguageCodeType = {
    en: 1,
    ru: 2,
    fr: 3,
    es: 4,
    de: 5,
    pl: 6,
    pt: 7,
    zh: 8,
    it: 9,
    el: 10,
    ko: 11,
    ja: 12,
    nl: 13,
    zhtw: 14,
};

export const LanguageCodeTypeDictionary = {
    1: 'en',
    2: 'ru',
    3: 'fr',
    4: 'es',
    5: 'de',
    6: 'pl',
    7: 'pt',
    8: 'zh',
    9: 'it',
    10: 'el',
    11: 'ko',
    12: 'ja',
    13: 'nl',
    14: 'zhtw',
};

export const SurveyQuestionMeaningType = {
    None: 0,
    CallDriver: 1,
    SecondaryCallDriver: 2,
    TertiaryCallDriver: 3,
    QuaternaryCallDriver: 4,
    Product: 5,
    SecondaryProduct: 6,
    TertiaryProduct: 7,
    QuaternaryProduct: 8,
    RepresentativeSatisfaction: 9,
    CompanySatisfaction: 10,
    ProductSatisfaction: 11,
    OverallSatisfaction: 12,
    Nps: 13,
    Resolution: 14,
    Repeat: 15,
    Comment: 16,
    Customer: 17,
};

export const SurveyQuestionMeaningTypeDictionary = {
    0: 'None',
    1: 'CallDriver',
    2: 'SecondaryCallDriver',
    3: 'TertiaryCallDriver',
    4: 'QuaternaryCallDriver',
    5: 'Product',
    6: 'SecondaryProduct',
    7: 'TertiaryProduct',
    8: 'QuaternaryProduct',
    9: 'RepresentativeSatisfaction',
    10: 'CompanySatisfaction',
    11: 'ProductSatisfaction',
    12: 'OverallSatisfaction',
    13: 'Nps',
    14: 'Resolution',
    15: 'Repeat',
    16: 'Comment',
    17: 'Customer',
};

export const IdentifierType = {
    ZUser: 1,
    SurveyForm: 2,
    SurveyQuestion: 3,
    SurveyQuestionPotentialResponse: 4,
    Survey: 5,
};

export const IdentifierTypeDictionary = {
    1: 'ZUser',
    2: 'SurveyForm',
    3: 'SurveyQuestion',
    4: 'SurveyQuestionPotentialResponse',
    5: 'Survey',
};

export const SubmitAction = {
    EssilorTransferToTechLine: 1,
};

export const SubmitActionDictionary = {
    1: 'EssilorTransferToTechLine',
};

export const SurveyQuestionInternalNameType = {
    RSAT: 1,
    RES: 2,
    RFC: 3,
    EOC: 4,
};

export const SurveyQuestionInternalNameTypeDictionary = {
    1: 'RSAT',
    2: 'RES',
    3: 'RFC',
    4: 'EOC',
};

export const ZendeskStatusType = {
    New: 1,
    Open: 2,
    Pending: 3,
    OnHold: 4,
    Solved: 5,
    Closed: 6,
    Deleted: 7,
};

export const ZendeskStatusTypeDictionary = {
    1: 'New',
    2: 'Open',
    3: 'Pending',
    4: 'OnHold',
    5: 'Solved',
    6: 'Closed',
    7: 'Deleted',
};

export const WIPAnswerDictionary = {
    Yes: 415367,
    No: 415368,
    PreviouslyReviewed: 415958,
};

export const WIPAnswerDictionaryDictionary = {
    415367: 'Yes',
    415368: 'No',
    415958: 'PreviouslyReviewed',
};

export const InteractionDirection = {
    Inbound: 1,
    Outbound: 2,
};

export const InteractionDirectionDictionary = {
    1: 'Inbound',
    2: 'Outbound',
};

export const ChannelType = {
    Phone: 1,
    Chat: 2,
    Email: 3,
    Web: 4,
    Api: 5,
    Social: 6,
    Whatsapp: 7,
    Retail: 8,
    Other: 9,
};

export const ChannelTypeDictionary = {
    1: 'Phone',
    2: 'Chat',
    3: 'Email',
    4: 'Web',
    5: 'Api',
    6: 'Social',
    7: 'Whatsapp',
    8: 'Retail',
    9: 'Other',
};

export const ReportTypeName = {
    ExportAllSurveyData: 1,
    ExportByTeam: 2,
    ExportByUser: 3,
    ExportCustomerSurveys: 4,
    AgentPerformanceReport: 5,
    ExportAllQaData: 6,
    AgentLastActiveReport: 8,
    ExportAgentAndCustomerResponses: 9,
    ExportMailgunData: 10,
    ExportAgentReturnedSurveys: 11,
    MissingAccountCalls: 12,
    ExportCustomerResponsePercentages: 13,
    ExportICDCampaignReport: 14,
    ExportMLBDissatisfiedReport: 15,
    ExportMasterReport: 16,
    ExportComplianceReport: 17,
    ExportBestPracticeAndProcessFailReport: 18,
    ExportCoachValidation: 19,
};

export const ReportTypeNameDictionary = {
    1: 'ExportAllSurveyData',
    2: 'ExportByTeam',
    3: 'ExportByUser',
    4: 'ExportCustomerSurveys',
    5: 'AgentPerformanceReport',
    6: 'ExportAllQaData',
    8: 'AgentLastActiveReport',
    9: 'ExportAgentAndCustomerResponses',
    10: 'ExportMailgunData',
    11: 'ExportAgentReturnedSurveys',
    12: 'MissingAccountCalls',
    13: 'ExportCustomerResponsePercentages',
    14: 'ExportICDCampaignReport',
    15: 'ExportMLBDissatisfiedReport',
    16: 'ExportMasterReport',
    17: 'ExportComplianceReport',
    18: 'ExportBestPracticeAndProcessFailReport',
    19: 'ExportCoachValidation',
};

export const ServerIdentity = {
    Default: 1,
    Development: 2,
    Rockstar: 4,
};

export const ServerIdentityDictionary = {
    1: 'Default',
    2: 'Development',
    4: 'Rockstar',
};

export const ContactType = {
    AccountManager: 1,
    SuccessManager: 2,
    PrimaryClientContact: 3,
    TechnicalClientContact: 4,
};

export const ContactTypeDictionary = {
    1: 'AccountManager',
    2: 'SuccessManager',
    3: 'PrimaryClientContact',
    4: 'TechnicalClientContact',
};

export const SurveyQuestionControlType = {
    MetadataLookupField: 1,
    Nps: 2,
};

export const SurveyQuestionControlTypeDictionary = {
    1: 'MetadataLookupField',
    2: 'Nps',
};

export const InteractionState = {
    Unknown: 1,
    Ringing: 2,
    Answered: 4,
    Transferred: 8,
    Conferenced: 16,
    Failed: 32,
    Completed: 64,
    CompletedByCustomer: 128,
    CompletedByAgent: 256,
    CompletedByUnknown: 512,
};

export const InteractionStateDictionary = {
    1: 'Unknown',
    2: 'Ringing',
    4: 'Answered',
    8: 'Transferred',
    16: 'Conferenced',
    32: 'Failed',
    64: 'Completed',
    128: 'CompletedByCustomer',
    256: 'CompletedByAgent',
    512: 'CompletedByUnknown',
};

export const OrderByDirection = {
    Asc: 0,
    Desc: 1,
};

export const OrderByDirectionDictionary = {
    0: 'Asc',
    1: 'Desc',
};

export const SurveyQuestionType = {
    Issue: 1,
    Product: 2,
    Satisfaction: 3,
    Resolution: 4,
    AgentControllable: 5,
    Repeat: 6,
    Customer: 7,
    Comment: 8,
    Title: 9,
    Miscellaneous: 10,
    ZTest: 11,
    NextGEN: 12,
};

export const SurveyQuestionTypeDictionary = {
    1: 'Issue',
    2: 'Product',
    3: 'Satisfaction',
    4: 'Resolution',
    5: 'AgentControllable',
    6: 'Repeat',
    7: 'Customer',
    8: 'Comment',
    9: 'Title',
    10: 'Miscellaneous',
    11: 'ZTest',
    12: 'NextGEN',
};

export const SurveyQuestionPotentialResponseType = {
    Text: 1,
    Int: 2,
    Bool: 3,
    Customer: 4,
    FreeText: 5,
    None: 6,
};

export const SurveyQuestionPotentialResponseTypeDictionary = {
    1: 'Text',
    2: 'Int',
    3: 'Bool',
    4: 'Customer',
    5: 'FreeText',
    6: 'None',
};

export const ServerEnvironmentType = {
    Development: 1,
    Staging: 2,
    Demo: 3,
    Production: 4,
};

export const ServerEnvironmentTypeDictionary = {
    1: 'Development',
    2: 'Staging',
    3: 'Demo',
    4: 'Production',
};

export const SurveyType = {
    Agent: 1,
    Calibrator: 2,
    Customer: 4,
    QA: 5,
};

export const SurveyTypeDictionary = {
    1: 'Agent',
    2: 'Calibrator',
    4: 'Customer',
    5: 'QA',
};

export const ZacousticPermission = {
    Insights: 1,
    ReportsFullAccess: 4,
    QaVisionPerformAudit: 5,
    QaVisionCreateEditForm: 8,
    QaVisionReviewCompletedAudits: 9,
    CalibratorStatusPage: 26,
    CalibratorCalibrateSurveys: 27,
    CalibratorAssignSurveys: 28,
    CalibratorAdministerCalibration: 29,
    AdminReviewUsers: 30,
    AdminCreateEditUsers: 31,
    AdminReviewTeams: 32,
    AdminAssignRemoveUsersToTeams: 33,
    AdminEditTeamStructures: 34,
    AdminViewAccountGroups: 35,
    AdminEditAccountGroups: 36,
    AdminCreateCustomizedAgentSurveyMessagesInAccountGroups: 37,
    AdminSeeRoles: 38,
    AdminCreateEditRoles: 40,
    Alerts: 42,
    AuraSurvey: 44,
    Harmony: 45,
    Portal: 52,
    Frontline: 53,
    Aura: 54,
    CalibrationDashboardManagerView: 56,
    CalibrationDashboardSupervisorView: 57,
    CalibrationDashboardAgentView: 58,
};

export const ZacousticPermissionDictionary = {
    1: 'Insights',
    4: 'ReportsFullAccess',
    5: 'QaVisionPerformAudit',
    8: 'QaVisionCreateEditForm',
    9: 'QaVisionReviewCompletedAudits',
    26: 'CalibratorStatusPage',
    27: 'CalibratorCalibrateSurveys',
    28: 'CalibratorAssignSurveys',
    29: 'CalibratorAdministerCalibration',
    30: 'AdminReviewUsers',
    31: 'AdminCreateEditUsers',
    32: 'AdminReviewTeams',
    33: 'AdminAssignRemoveUsersToTeams',
    34: 'AdminEditTeamStructures',
    35: 'AdminViewAccountGroups',
    36: 'AdminEditAccountGroups',
    37: 'AdminCreateCustomizedAgentSurveyMessagesInAccountGroups',
    38: 'AdminSeeRoles',
    40: 'AdminCreateEditRoles',
    42: 'Alerts',
    44: 'AuraSurvey',
    45: 'Harmony',
    52: 'Portal',
    53: 'Frontline',
    54: 'Aura',
    56: 'CalibrationDashboardManagerView',
    57: 'CalibrationDashboardSupervisorView',
    58: 'CalibrationDashboardAgentView',
};

export const AgentCalibrationStatusFullHistoryTableColumns = {
    Id: 'Id',
    UserId: 'UserId',
    SurveyQuestionId: 'SurveyQuestionId',
    StartDate: 'StartDate',
    ExpirationDate: 'ExpirationDate',
    CalibrationStatusId: 'CalibrationStatusId',
    CalibrationScore: 'CalibrationScore',
    NumberOfInteraction: 'NumberOfInteraction',
    TicketId: 'TicketId',
    Method: 'Method',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const AgentJibeHistoryTableColumns = {
    UserId: 'UserId',
    JibeDate: 'JibeDate',
    QuestionCode: 'QuestionCode',
    WindowStart: 'WindowStart',
    WindowEnd: 'WindowEnd',
    FirstSurveyDate: 'FirstSurveyDate',
    LastSurveyDate: 'LastSurveyDate',
    Period: 'Period',
    RealPeriod: 'RealPeriod',
    Surveys: 'Surveys',
    TruePositive: 'TruePositive',
    TrueNegative: 'TrueNegative',
    FalsePositive: 'FalsePositive',
    FalseNegative: 'FalseNegative',
    SameDaySurveys: 'SameDaySurveys',
    SameDayTruePositive: 'SameDayTruePositive',
    SameDayTrueNegative: 'SameDayTrueNegative',
    SameDayFalsePositive: 'SameDayFalsePositive',
    SameDayFalseNegative: 'SameDayFalseNegative',
    OveralSuccessRatePercent: 'OveralSuccessRatePercent',
    PositiveSuccessRatePercent: 'PositiveSuccessRatePercent',
    NegativeSuccessRatePercent: 'NegativeSuccessRatePercent',
};

export const AgentPredictionCustomerResponseMatchingScoreTableColumns = {
    Id: 'Id',
    AgentSurveyQuestionPotentialResponseId: 'AgentSurveyQuestionPotentialResponseId',
    CustomerSurveyQuestionPotentialResponseId: 'CustomerSurveyQuestionPotentialResponseId',
    MatchingScore: 'MatchingScore',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const BestPracticeTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    SurveyResultId: 'SurveyResultId',
    ReasonForContactId: 'ReasonForContactId',
    SurveyQuestionPotentialResponseId: 'SurveyQuestionPotentialResponseId',
    GeneratedByUserId: 'GeneratedByUserId',
    Title: 'Title',
    Description: 'Description',
    CurrentProcess: 'CurrentProcess',
    SuggestedSolution: 'SuggestedSolution',
    AdditionalNotes: 'AdditionalNotes',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const BestPracticeConfigTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    Key: 'Key',
    Value: 'Value',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CalabrioInteractionTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    InteractionId: 'InteractionId',
    InteractionId2: 'InteractionId2',
    RecordingId: 'RecordingId',
    RecordingUrl: 'RecordingUrl',
    Ani: 'Ani',
    IsIncoming: 'IsIncoming',
    IsExternal: 'IsExternal',
    TalkTimeSeconds: 'TalkTimeSeconds',
    HandleTimeSeconds: 'HandleTimeSeconds',
    HoldTimeSeconds: 'HoldTimeSeconds',
    IvrTimeSeconds: 'IvrTimeSeconds',
    WrapTimeSeconds: 'WrapTimeSeconds',
    RingTimeSeconds: 'RingTimeSeconds',
    StartTime: 'StartTime',
    EndTime: 'EndTime',
    CustomData: 'CustomData',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CalibrationDateWindowTableColumns = {
    BaseDate: 'BaseDate',
    WindowEnd: 'WindowEnd',
    WindowStart90: 'WindowStart90',
    WindowStart120: 'WindowStart120',
    WindowStart150: 'WindowStart150',
    WindowStart180: 'WindowStart180',
};

export const ClientTableColumns = {
    Id: 'Id',
    Name: 'Name',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ClientSettingTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    Key: 'Key',
    Value: 'Value',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ClientSiteTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    TimeZoneId: 'TimeZoneId',
    ExternalId: 'ExternalId',
    Name: 'Name',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CoachingSessionTableColumns = {
    Id: 'Id',
    AgentId: 'AgentId',
    TrainerId: 'TrainerId',
    ReasonForContactId: 'ReasonForContactId',
    SessionDate: 'SessionDate',
    Note: 'Note',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CustomerTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    ClientSiteId: 'ClientSiteId',
    ExternalId: 'ExternalId',
    Name: 'Name',
    Email: 'Email',
    AccountNumber: 'AccountNumber',
    TypeOfLanguageId: 'TypeOfLanguageId',
    Ordinal: 'Ordinal',
    AgentPromoQuestionCount: 'AgentPromoQuestionCount',
    LastDateAgentPromoQuestionAnsweredYes: 'LastDateAgentPromoQuestionAnsweredYes',
    IsEnabled: 'IsEnabled',
    UnsubscribedSurveyEmail: 'UnsubscribedSurveyEmail',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CustomerDailyWipTableColumns = {
    Id: 'Id',
    CustomerId: 'CustomerId',
    WipDate: 'WipDate',
    UserId: 'UserId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CustomerPhoneTableColumns = {
    Id: 'Id',
    CustomerId: 'CustomerId',
    Phone: 'Phone',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CustomerPropertyTableColumns = {
    Id: 'Id',
    CustomerId: 'CustomerId',
    CustomerPropertyKeyId: 'CustomerPropertyKeyId',
    Value: 'Value',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CustomerPropertyKeyTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    ExternalId: 'ExternalId',
    Name: 'Name',
    DisplayName: 'DisplayName',
    IsPivotable: 'IsPivotable',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const CustomerSurveyLinkTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    ZacousticTicketId: 'ZacousticTicketId',
    CustomerId: 'CustomerId',
    EmailId: 'EmailId',
    AccessKey: 'AccessKey',
    ProductType: 'ProductType',
    LogoLink: 'LogoLink',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const DoNotContactEmailAddressTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    EmailAddress: 'EmailAddress',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const EmailTableColumns = {
    Id: 'Id',
    SourceTag: 'SourceTag',
    ToEmail: 'ToEmail',
    ToName: 'ToName',
    FromEmail: 'FromEmail',
    FromName: 'FromName',
    Subject: 'Subject',
    IsHtml: 'IsHtml',
    Body: 'Body',
    ScheduledSendDate: 'ScheduledSendDate',
    DateSent: 'DateSent',
    SentSuccessfully: 'SentSuccessfully',
    IsDeleted: 'IsDeleted',
    DateCreated: 'DateCreated',
};

export const EvaluationGen2TableColumns = {
    Id: 'Id',
    QaSurveyId: 'QaSurveyId',
    AgentUserId: 'AgentUserId',
    CoachUserId: 'CoachUserId',
    CoachDesc: 'CoachDesc',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const EventTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    Name: 'Name',
    Value: 'Value',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const GameTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    Name: 'Name',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const InteractionTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    ZacousticTicketId: 'ZacousticTicketId',
    UserId: 'UserId',
    TypeId: 'TypeId',
    AuditId: 'AuditId',
    ExternalId: 'ExternalId',
    RecordingExternalId: 'RecordingExternalId',
    RecordingUrl: 'RecordingUrl',
    Ani: 'Ani',
    IsIncoming: 'IsIncoming',
    IsExternal: 'IsExternal',
    IsTransferred: 'IsTransferred',
    StartTime: 'StartTime',
    EndTime: 'EndTime',
    LastUpdated: 'LastUpdated',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const JibeSessionTableColumns = {
    Id: 'Id',
    AgentId: 'AgentId',
    TrainerId: 'TrainerId',
    SessionDate: 'SessionDate',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const LanguageDictionaryTableColumns = {
    Id: 'Id',
    Code: 'Code',
    EnglishText: 'EnglishText',
    ForeignText: 'ForeignText',
    LanguageId: 'LanguageId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const LogZUserAccessTableColumns = {
    Id: 'Id',
    UserId: 'UserId',
    LoginDate: 'LoginDate',
    LogoutDate: 'LogoutDate',
    AccessToken: 'AccessToken',
    RefreshToken: 'RefreshToken',
    Expires: 'Expires',
    LastActive: 'LastActive',
    LastActiveDesktop: 'LastActiveDesktop',
    DesktopName: 'DesktopName',
    DesktopVersion: 'DesktopVersion',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const PermissionTableColumns = {
    Id: 'Id',
    Name: 'Name',
    CategoryName: 'CategoryName',
    Ordinal: 'Ordinal',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const PredefinedQuestionTableColumns = {
    Id: 'Id',
    Name: 'Name',
    ShortName: 'ShortName',
    Description: 'Description',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const PredictionJibeStatusTableColumns = {
    Id: 'Id',
    SurveyFieldId: 'SurveyFieldId',
    JibeStatus: 'JibeStatus',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
    Method: 'Method',
};

export const ProcessFailureTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    SurveyResultId: 'SurveyResultId',
    ReasonForContactId: 'ReasonForContactId',
    SurveyQuestionPotentialResponseId: 'SurveyQuestionPotentialResponseId',
    GeneratedByUserId: 'GeneratedByUserId',
    TypeOfProcessFailureStatusId: 'TypeOfProcessFailureStatusId',
    Title: 'Title',
    Description: 'Description',
    CurrentProcess: 'CurrentProcess',
    SuggestedSolution: 'SuggestedSolution',
    AdditionalNotes: 'AdditionalNotes',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ProcessFailureConfigTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    Key: 'Key',
    Value: 'Value',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const QScanItemScoreTableColumns = {
    Id: 'Id',
    AreaTypeId: 'AreaTypeId',
    RespondentTypeId: 'RespondentTypeId',
    Value: 'Value',
    Score: 'Score',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ReasonForContactTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    Name: 'Name',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ResponseMappingTableColumns = {
    QuestionCode: 'QuestionCode',
    AgentResponseId: 'AgentResponseId',
    CustomerResponseId: 'CustomerResponseId',
    AgentResponseType: 'AgentResponseType',
    CustomerResponseType: 'CustomerResponseType',
    AgentResponseCategory: 'AgentResponseCategory',
    MatchingScore: 'MatchingScore',
};

export const SurveyCommentTableColumns = {
    Id: 'Id',
    SurveyId: 'SurveyId',
    Value: 'Value',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const SurveyFieldTableColumns = {
    Id: 'Id',
    SurveyId: 'SurveyId',
    SurveyQuestionId: 'SurveyQuestionId',
    SurveyQuestionPotentialResponseId: 'SurveyQuestionPotentialResponseId',
    DateCreated: 'DateCreated',
    LastUpdated: 'LastUpdated',
    IsDeleted: 'IsDeleted',
};

export const SurveyFieldFreeTextTableColumns = {
    Id: 'Id',
    SurveyId: 'SurveyId',
    SurveyQuestionId: 'SurveyQuestionId',
    Value: 'Value',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const SurveyFormTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    TypeId: 'TypeId',
    Name: 'Name',
    IsEnabled: 'IsEnabled',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const SurveyFormSectionTableColumns = {
    Id: 'Id',
    SurveyFormId: 'SurveyFormId',
    Name: 'Name',
    Display: 'Display',
    Ordinal: 'Ordinal',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const SurveyQuestionTableColumns = {
    Id: 'Id',
    SurveyFormId: 'SurveyFormId',
    PredefinedQuestionId: 'PredefinedQuestionId',
    TypeId: 'TypeId',
    UniqueId: 'UniqueId',
    SurveyFormSectionId: 'SurveyFormSectionId',
    Name: 'Name',
    ClientSpecificShortName: 'ClientSpecificShortName',
    DisplayText: 'DisplayText',
    Ordinal: 'Ordinal',
    MaxPoints: 'MaxPoints',
    AllowMultiple: 'AllowMultiple',
    IsCalibratedOn: 'IsCalibratedOn',
    IsRequiredAnswered: 'IsRequiredAnswered',
    IsEnabled: 'IsEnabled',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const SurveyQuestionLanguageLookupTableColumns = {
    Id: 'Id',
    SurveyQuestionId: 'SurveyQuestionId',
    CustomerFacingText: 'CustomerFacingText',
    LanguageId: 'LanguageId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const SurveyQuestionPotentialResponseTableColumns = {
    Id: 'Id',
    SurveyQuestionId: 'SurveyQuestionId',
    UniqueId: 'UniqueId',
    Ordinal: 'Ordinal',
    PerformanceResponseTypeId: 'PerformanceResponseTypeId',
    IconTypeId: 'IconTypeId',
    IconType: 'IconType',
    Value: 'Value',
    ShortName: 'ShortName',
    ExternalName: 'ExternalName',
    PointValue: 'PointValue',
    IsDefault: 'IsDefault',
    IsEnabled: 'IsEnabled',
    IsNotScored: 'IsNotScored',
    IsZeroMaker: 'IsZeroMaker',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const SurveyResultTableColumns = {
    Id: 'Id',
    SurveyFormId: 'SurveyFormId',
    UserId: 'UserId',
    ZacousticTicketId: 'ZacousticTicketId',
    ExternalId: 'ExternalId',
    AuditedAgentId: 'AuditedAgentId',
    IsSubmitted: 'IsSubmitted',
    IsSkipped: 'IsSkipped',
    DesktopMarkedRendered: 'DesktopMarkedRendered',
    SubmissionDate: 'SubmissionDate',
    LastUpdated: 'LastUpdated',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const TeamTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    CreatedByUserId: 'CreatedByUserId',
    ClientSiteId: 'ClientSiteId',
    Name: 'Name',
    ExternalId: 'ExternalId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const TeamMemberTableColumns = {
    Id: 'Id',
    TeamId: 'TeamId',
    UserId: 'UserId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const TemporaryLinkTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    UserId: 'UserId',
    TypeKey: 'TypeKey',
    LinkText: 'LinkText',
    ResetToken: 'ResetToken',
    IsUsed: 'IsUsed',
    DateExpires: 'DateExpires',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZacousticTicketTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    ExternalId: 'ExternalId',
    ExternalNumber: 'ExternalNumber',
    TicketAssigneeId: 'TicketAssigneeId',
    ChannelTypeId: 'ChannelTypeId',
    ReasonForContactId: 'ReasonForContactId',
    LanguageId: 'LanguageId',
    GameId: 'GameId',
    CustomerId: 'CustomerId',
    CustomerExternalId: 'CustomerExternalId',
    StatusId: 'StatusId',
    Tags: 'Tags',
    TotalTimeSpentInSecond: 'TotalTimeSpentInSecond',
    ExternalOpenDate: 'ExternalOpenDate',
    ExternalCloseDate: 'ExternalCloseDate',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
    LastUpdated: 'LastUpdated',
    LastReopenDate: 'LastReopenDate',
    FirstResolutionDate: 'FirstResolutionDate',
    CustomerSurveyWasSentAt: 'CustomerSurveyWasSentAt',
};

export const ZendeskReasonForContactCategoryTableColumns = {
    Id: 'Id',
    ReasonForContactId: 'ReasonForContactId',
    Name: 'Name',
    CategoryName: 'CategoryName',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZFileTableColumns = {
    Id: 'Id',
    GuidId: 'GuidId',
    FileSetId: 'FileSetId',
    FileTypeId: 'FileTypeId',
    Name: 'Name',
    HashedId: 'HashedId',
    ContentType: 'ContentType',
    Extension: 'Extension',
    Size: 'Size',
    ImageHeight: 'ImageHeight',
    ImageWidth: 'ImageWidth',
    CroppingInformation: 'CroppingInformation',
    UploaderUserId: 'UploaderUserId',
    Stream: 'Stream',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZFileSetTableColumns = {
    Id: 'Id',
    UserId: 'UserId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZRoleTableColumns = {
    Id: 'Id',
    Name: 'Name',
    ExternalName: 'ExternalName',
    Description: 'Description',
    Ordinal: 'Ordinal',
    IsReadOnly: 'IsReadOnly',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZRolePermissionTableColumns = {
    Id: 'Id',
    RoleId: 'RoleId',
    PermissionId: 'PermissionId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZTimeZoneTableColumns = {
    Id: 'Id',
    ExternalId: 'ExternalId',
    OffsetMinutes: 'OffsetMinutes',
    DSTOffsetMinutes: 'DSTOffsetMinutes',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZUserTableColumns = {
    Id: 'Id',
    ClientId: 'ClientId',
    RoleId: 'RoleId',
    FileSetId: 'FileSetId',
    ExternalId: 'ExternalId',
    Name: 'Name',
    UserName: 'UserName',
    Alias: 'Alias',
    PasswordHash: 'PasswordHash',
    SecurityStamp: 'SecurityStamp',
    Email: 'Email',
    EmailConfirmed: 'EmailConfirmed',
    PhoneNumber: 'PhoneNumber',
    PhoneNumberConfirmed: 'PhoneNumberConfirmed',
    TimeZoneId: 'TimeZoneId',
    TwoFactorEnabled: 'TwoFactorEnabled',
    IsEmployee: 'IsEmployee',
    HireDate: 'HireDate',
    IsTerminated: 'IsTerminated',
    TerminationDate: 'TerminationDate',
    LockoutEndDateUtc: 'LockoutEndDateUtc',
    LockoutEnabled: 'LockoutEnabled',
    AccessFailedCount: 'AccessFailedCount',
    MustChangePassword: 'MustChangePassword',
    ForceRefresh: 'ForceRefresh',
    IsEditable: 'IsEditable',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZUserClaimTableColumns = {
    Id: 'Id',
    UserId: 'UserId',
    ClaimType: 'ClaimType',
    ClaimValue: 'ClaimValue',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZUserLoginTableColumns = {
    LoginProvider: 'LoginProvider',
    ProviderKey: 'ProviderKey',
    UserId: 'UserId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZUserRelationshipTableColumns = {
    Id: 'Id',
    ParentUserId: 'ParentUserId',
    UserId: 'UserId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};

export const ZUserRoleTableColumns = {
    Id: 'Id',
    UserId: 'UserId',
    RoleId: 'RoleId',
    DateCreated: 'DateCreated',
    IsDeleted: 'IsDeleted',
};
